"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkbox = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _helpers = require("../../helpers");

var _Flex = require("../Flex");

var _svgs = require("../../svgs");

var _styledSystem = require("styled-system");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Spec: zpl.io/bAvnwlB
 */
var SIZE = 2;
var BORDER_WIDTH = 2;

/**
 * A checkbox
 */
var Checkbox =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Checkbox, _React$Component);

  function Checkbox() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Checkbox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Checkbox)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "labelColor", function () {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          error = _this$props.error;
      if (disabled) return {
        color: (0, _helpers.color)("black10")
      };
      if (error) return {
        color: (0, _helpers.color)("red100")
      };
    });

    _defineProperty(_assertThisInitialized(_this), "iconColor", function () {
      var _this$props2 = _this.props,
          disabled = _this$props2.disabled,
          selected = _this$props2.selected;
      if (disabled && selected) return "black30";
      if (disabled) return "black5";
      return "white100";
    });

    return _this;
  }

  _createClass(Checkbox, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          selected = _this$props3.selected,
          children = _this$props3.children,
          error = _this$props3.error,
          disabled = _this$props3.disabled,
          hover = _this$props3.hover;
      return _react.default.createElement(Container, {
        className: hover && "hover",
        my: 0.5,
        onClick: function onClick() {
          return !disabled && _this2.props.onSelect && _this2.props.onSelect(!selected);
        },
        selected: selected,
        hover: hover,
        disabled: disabled,
        alignItems: "center"
      }, _react.default.createElement(CheckboxButton, {
        border: 1,
        mr: 1,
        selected: selected,
        error: error,
        disabled: disabled
      }, _react.default.createElement(_svgs.CheckIcon, {
        fill: this.iconColor()
      })), _react.default.createElement(Label, {
        style: this.labelColor()
      }, children));
    }
  }]);

  return Checkbox;
}(_react.default.Component);

exports.Checkbox = Checkbox;
Checkbox.displayName = "Checkbox";

var checkBorderColor = function checkBorderColor(_ref) {
  var disabled = _ref.disabled,
      selected = _ref.selected,
      error = _ref.error;
  if (disabled) return (0, _helpers.color)("black10");
  if (selected) return (0, _helpers.color)("black100");
  if (error) return (0, _helpers.color)("red100");
  return (0, _helpers.color)("black10");
};

var checkBackgroundColor = function checkBackgroundColor(_ref2) {
  var disabled = _ref2.disabled,
      selected = _ref2.selected;

  switch (true) {
    case disabled:
      return (0, _helpers.color)("black5");

    case selected:
      return (0, _helpers.color)("black100");

    default:
      return (0, _helpers.color)("white100");
  }
};

var CheckboxButton = _styledComponents.default.div.withConfig({
  displayName: "Checkbox__CheckboxButton",
  componentId: "j97vg8-0"
})(["", ";", ";background-color:", ";border-color:", ";width:", "px;height:", "px;transition:background-color 0.25s,border-color 0.25s;svg{position:relative;top:-", "px;left:-", "px;}"], _styledSystem.borders, _styledSystem.space, checkBackgroundColor, checkBorderColor, (0, _helpers.space)(SIZE), (0, _helpers.space)(SIZE), BORDER_WIDTH, BORDER_WIDTH);

var Label = _styledComponents.default.div.withConfig({
  displayName: "Checkbox__Label",
  componentId: "j97vg8-1"
})([""]);

var hoverStyles = function hoverStyles(_ref3) {
  var selected = _ref3.selected,
      hover = _ref3.hover,
      disabled = _ref3.disabled;
  var styles = "\n    background-color: ".concat((0, _helpers.color)("black10"), ";\n    border-color: ").concat((0, _helpers.color)("black10"), ";\n  ");

  if (hover && !selected && !disabled) {
    return (0, _styledComponents.css)(["", "{", ";}"], CheckboxButton, styles);
  }

  if (!selected && !disabled) {
    return (0, _styledComponents.css)(["&:hover ", "{", ";}"], CheckboxButton, styles);
  }
};

var Container = (0, _styledComponents.default)(_Flex.Flex).withConfig({
  displayName: "Checkbox__Container",
  componentId: "j97vg8-2"
})(["user-select:none;cursor:", ";transition:color 0.25s;", ";"], function (_ref4) {
  var disabled = _ref4.disabled;
  return !disabled && "pointer";
}, hoverStyles);
//# sourceMappingURL=Checkbox.js.map